export default __webpack_public_path__ + "static/media/02_DAIF_Services_02.2486e20d.mp4";